module.exports = __webpack_public_path__ + "static/media/Basil Haydens_Virtual_Event.136ed0f2.jpg";